import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@app/models/api/ApiRespose.model';
import { EstatusMigratorioDto } from '@app/_models/EstatusMigratorioDto';
import { baseUrl, environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstatusMigratorioService {

  constructor(private httpClient: HttpClient) { }

    /**
   * Metodo para obtener catalogo de raza
   * @returns 
   */
     public obtenerEstatusMigratorio(): Observable<ApiResponse<EstatusMigratorioDto[]>> {
      return this.httpClient.get<ApiResponse<EstatusMigratorioDto[]>>(`${environment.enves[baseUrl].apiUrl}/EstatusMigratorio/ObtenerEstatusMigratorio`);
    }
}
